/*
 * 请求响应的状态码及状态码对应的含义
 */
export default {
    '401': '认证失败，无法访问系统资源',
    '403': '当前操作没有权限',
    '404': '访问资源不存在',
    'default': '系统未知错误，请反馈给管理员',
    '405': '方法不被允许',
    '408': '请求超时',
    '500': '服务器内部错误',
    '501': '服务未实现',
    '502': '网关错误',
    '503': '服务不可用',
    '504': '网关超时',
    '505': 'HTTP版本不受支持'
  }